// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'bootstrap/dist/js/bootstrap.bundle'
import 'admin-lte'
import "@fortawesome/fontawesome-free/js/all"
import '../stylesheets/application.scss'

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
global.RailsUJS = Rails
// Turbolinks.start()
ActiveStorage.start()
window.fncShowDetailConditions = function(){
  $('#detail_conditions').show();
  $('#detail_conditions_show_btn').hide();
}
window.fncOpenMemoModal = function (spot_id) {
  $('#memo_modal textarea').data('spot-id', spot_id);
  const text = $('.spot-' + spot_id + ' .memo').val();
  $('#memo_modal textarea').val(text).focus();
  $('#memo_modal').modal('show');
}
window.fncCloseMemoModal = function () {
  const spot_id = $('#memo_modal textarea').data('spot-id');
  const text = $('#memo_modal textarea').val();
  $('.spot-' + spot_id + ' .memo').val(text).change();
  $('#memo_modal').modal('hide');
}
window.fncOpenFreeTextBoardModal = function (spot_id) {
  $('#free_text_board_modal textarea').data('spot-id', spot_id);
  const text = $('.spot-' + spot_id + ' .free_text_board').val();
  $('#free_text_board_modal textarea').val(text).focus();
  $('#free_text_board_modal').modal('show');
}
window.fncCloseFreeTextBoardModal = function () {
  const spot_id = $('#free_text_board_modal textarea').data('spot-id');
  const text = $('#free_text_board_modal textarea').val();
  $('.spot-' + spot_id + ' .free_text_board').val(text).change();
  $('#free_text_board_modal').modal('hide');
}
window.fncShowSpotDetail = function (spot_id) {
  $('.spot-' + spot_id + ' .spot-detail-show-btn').hide();
  $('.spot-' + spot_id + ' .spot-detail-hide-btn').show();
  $('.spot-detail.spot-' + spot_id).show();
}
window.fncHideSpotDetail = function (spot_id) {
  $('.spot-' + spot_id + ' .spot-detail-show-btn').show();
  $('.spot-' + spot_id + ' .spot-detail-hide-btn').hide();
  $('.spot-detail.spot-' + spot_id).hide();
}
window.submitDoctorUpdateForm = function(spot_id) {
  let loading = document.querySelector('tr.spot-' + spot_id + ' .lock_version').dataset.loading;
  if(loading === '1') { // 処理中
    setTimeout(function() {
      submitDoctorUpdateForm(spot_id);
    }, 100);
  } else {
    document.querySelector('tr.spot-' + spot_id + ' .lock_version').dataset.loading = '1';
    const form = document.getElementById('reray_doctor_spot_form');
    //
    const lock_version = document.querySelector('tr.spot-' + spot_id + ' .lock_version').value;
    form.querySelector('[name="reray_doctor_spot[lock_version]"]').value = lock_version;
    //
    form.querySelector('[name="spot_id"]').value = spot_id;
    //
    const customer_checked_flag = document.querySelector('tr.spot-' + spot_id + ' .customer_checked_flag:checked');
    if (customer_checked_flag === null) {
      form.querySelector('[name="reray_doctor_spot[customer_checked_flag]"]').value = '0';
    } else {
      form.querySelector('[name="reray_doctor_spot[customer_checked_flag]"]').value = '1';
    }
    //
    const reray_spot_status_type_id = document.querySelector('tr.spot-' + spot_id + ' .reray_spot_status_type_id').value;
    form.querySelector('[name="reray_doctor_spot[reray_spot_status_type_id]"]').value = reray_spot_status_type_id;
    //
    const apply_user_name = document.querySelector('tr.spot-' + spot_id + ' .apply_user_name').value;
    form.querySelector('[name="reray_doctor_spot[apply_user_name]"]').value = apply_user_name;
    //
    const employment_agency_name = document.querySelector('tr.spot-' + spot_id + ' .employment_agency_name').value;
    form.querySelector('[name="reray_doctor_spot[employment_agency_name]"]').value = employment_agency_name;
    //
    const fee_amount = document.querySelector('tr.spot-' + spot_id + ' .fee_amount').value;
    form.querySelector('[name="reray_doctor_spot[fee_amount]"]').value = fee_amount;
    //
    const memo = document.querySelector('tr.spot-' + spot_id + ' .memo').value;
    form.querySelector('[name="reray_doctor_spot[memo]"]').value = memo;
    //
    const free_text_board = document.querySelector('tr.spot-' + spot_id + ' .free_text_board').value;
    form.querySelector('[name="reray_doctor_spot[free_text_board]"]').value = free_text_board;
    console.log(RailsUJS.fire(form, 'submit'));
  }
};

window.submitComedicalUpdateForm = function(spot_id) {
  let loading = document.querySelector('tr.spot-' + spot_id + ' .lock_version').dataset.loading;
  if(loading === '1') { // 処理中
    setTimeout(function() {
      submitComedicalUpdateForm(spot_id);
    }, 100);
  } else {
    document.querySelector('tr.spot-' + spot_id + ' .lock_version').dataset.loading = '1';
    const form = document.getElementById('reray_comedical_spot_form');
    //
    const lock_version = document.querySelector('tr.spot-' + spot_id + ' .lock_version').value;
    form.querySelector('[name="reray_comedical_spot[lock_version]"]').value = lock_version;
    //
    form.querySelector('[name="spot_id"]').value = spot_id;
    //
    const customer_checked_flag = document.querySelector('tr.spot-' + spot_id + ' .customer_checked_flag:checked');
    if (customer_checked_flag === null) {
      form.querySelector('[name="reray_comedical_spot[customer_checked_flag]"]').value = '0';
    } else {
      form.querySelector('[name="reray_comedical_spot[customer_checked_flag]"]').value = '1';
    }
    //
    const reray_spot_status_type_id = document.querySelector('tr.spot-' + spot_id + ' .reray_spot_status_type_id').value;
    form.querySelector('[name="reray_comedical_spot[reray_spot_status_type_id]"]').value = reray_spot_status_type_id;
    //
    const apply_user_name = document.querySelector('tr.spot-' + spot_id + ' .apply_user_name').value;
    form.querySelector('[name="reray_comedical_spot[apply_user_name]"]').value = apply_user_name;
    //
    const employment_agency_name = document.querySelector('tr.spot-' + spot_id + ' .employment_agency_name').value;
    form.querySelector('[name="reray_comedical_spot[employment_agency_name]"]').value = employment_agency_name;
    //
    const fee_amount = document.querySelector('tr.spot-' + spot_id + ' .fee_amount').value;
    form.querySelector('[name="reray_comedical_spot[fee_amount]"]').value = fee_amount;
    //
    const memo = document.querySelector('tr.spot-' + spot_id + ' .memo').value;
    form.querySelector('[name="reray_comedical_spot[memo]"]').value = memo;
    //
    const free_text_board = document.querySelector('tr.spot-' + spot_id + ' .free_text_board').value;
    form.querySelector('[name="reray_comedical_spot[free_text_board]"]').value = free_text_board;
    console.log(RailsUJS.fire(form, 'submit'));
  }
};

import j9 from 'jquery'
window.j9 = j9

window.messageFromRecruiterUnreadAllCountSetFnc = function() {
  j9.ajax({
    type: 'GET',
    url: '/customers/reray_recruiters.json',
    dataType: 'json',
    success: function(data) {
      if(data.unread_all_count >= 1) {
        let $badge = j9('<span class="badge bg-danger"></span>').text(data.unread_all_count)
        $badge.appendTo('.sidebar #reray_recruiters a > p')
      }
    }
  })
}

window.messageFromCustomerUnreadAllCountSetFnc = function() {
  j9.ajax({
    type: 'GET',
    url: '/recruiters/customers.json',
    dataType: 'json',
    success: function(data) {
      if(data.unread_all_count >= 1) {
        let $badge = j9('<span class="badge bg-danger"></span>').text(data.unread_all_count)
        $badge.appendTo('.sidebar #customers a > p')
      }
    }
  })
}

import "../src/lity.min"
import "../src/reray_message"
